/* eslint-disable import/no-unresolved */
import {
    Breadcrumb, Table, Input, Button,
} from 'appkit-react';
import { Row, Col } from 'react-bootstrap';

import DefaultAlert from 'views/Shared/components/DefaultAlert';
import CreateProjectModal from '../CreateProjectModal/CreateProjectModal';
import NestedTable from '../NestedTable/NestedTable';

const Project = ({
    breadcrumbItems, showModal, setShowModal, dataForUpdate, tenantId,
    dataForClone, copyProjectFlag, setCopyProjectFlag, getProjectHierarchy,
    setToastMessage, toastMessage, filterString, setFilterString, setDataForClone,
    setDataForUpdate, tableDatasource, columns, subColumns,
}) => (
    <>
        <div className="true-comply-projects_page">
            <Breadcrumb items={breadcrumbItems} className="project-page-breadcrumb" />
            <Row>
                <Col style={{ marginTop: '0.5rem' }}>

                    {showModal
                        && (
                            <CreateProjectModal
                                visibleFlag
                                setShowModal={setShowModal}
                                projectData={dataForUpdate}
                                tenantId={tenantId}
                                dataForClone={dataForClone}
                                copyProjectFlag={copyProjectFlag}
                                setCopyProjectFlag={setCopyProjectFlag}
                                fetchData={getProjectHierarchy.refetch}
                                setToastMessage={setToastMessage}
                            />
                        )}

                    <div className="table-container" style={{ marginBottom: '3rem' }}>
                        {toastMessage
                            && (
                                <DefaultAlert
                                    status="success"
                                    toastMessage={toastMessage}
                                    setToastMessage={setToastMessage}
                                />
                            )}
                        <Row style={{ marginBottom: '1.1rem' }}>
                            <Col>
                                <h3 className="page-title">
                                    My projects
                                </h3>
                            </Col>
                            <Col style={{ paddingRight: 0 }}>
                                <div className="secondary-input-container a-apply-theme-background-gray-level-2" style={{ width: '70%', float: 'right' }}>
                                    <Input
                                        prefix={(
                                            <span
                                                className="icon-search-outline appkiticon change-color-with-focus"
                                                style={{ fontSize: 16 }}
                                            />
                                        )}
                                        inputBoxSize="sm"
                                        placeholder="Search"
                                        value={filterString}
                                        onChange={e => setFilterString(e)}
                                    />
                                </div>
                            </Col>
                            <Col md={2} style={{ paddingLeft: 0 }}>
                                <Button
                                    size="lg"
                                    onClick={
                                        () => {
                                            setShowModal(true);
                                            setDataForUpdate({});
                                            setDataForClone({});
                                        }
                                    }
                                    style={{ marginBottom: '0.5rem', float: 'right' }}
                                >
                                    <span className="appkiticon icon-plus-fill" />
                                    CREATE PROJECT
                                </Button>
                            </Col>
                        </Row>
                        <Table
                            data={tableDatasource || []}
                            columns={columns}
                            defaultPageSize={10}
                            sortable
                            size="lg"
                            resizable
                            className="-striped -highlight ReactTable rt-expander"
                            SubComponent={row => {
                                if (row.original.children.length > 0) {
                                    return (
                                        <div style={{ padding: '5px 0 10px 0px' }}>
                                            <NestedTable original={row.original} columns={subColumns} />
                                        </div>
                                    );
                                }
                                return <span />;
                            }}
                        />
                    </div>
                </Col>
            </Row>
        </div>
    </>
);

export default Project;
